"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _chrome = _interopRequireDefault(require("./chrome.svg"));

var _firefox = _interopRequireDefault(require("./firefox.svg"));

var BrowserWarningMessageEN = function BrowserWarningMessageEN(_ref) {
  var onBrowserSelect = _ref.onBrowserSelect;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: 'text-center padding-right-1pct padding-left-1pct'
  }, /*#__PURE__*/_react.default.createElement("h1", {
    className: 'margin-bottom-25 padding-top-25'
  }, 'You are using an outdated browser'), /*#__PURE__*/_react.default.createElement("p", {
    className: 'text-size-18 margin-bottom-25'
  }, 'With just under 7 years the ', /*#__PURE__*/_react.default.createElement("b", null, 'Internet Explorer'), ' is slowly getting old and can no longer keep up with modern browsers in terms of ', /*#__PURE__*/_react.default.createElement("b", null, 'speed'), ', ', /*#__PURE__*/_react.default.createElement("b", null, 'functionality'), ' but above all in terms of ', /*#__PURE__*/_react.default.createElement("b", null, 'security'), '.'), /*#__PURE__*/_react.default.createElement("p", {
    className: 'text-size-18 margin-bottom-25'
  }, 'We at RIO, have set ourselves the goal of providing you with the ', /*#__PURE__*/_react.default.createElement("b", null, 'best possible software'), ' to offer you the ', /*#__PURE__*/_react.default.createElement("b", null, 'best possible user experience'), '. Therefore, we have decided to end the support for the IE11.'), /*#__PURE__*/_react.default.createElement("p", {
    className: 'text-size-18'
  }, /*#__PURE__*/_react.default.createElement("b", null, 'Experience RIO from a whole new side with a modern browser:'))), /*#__PURE__*/_react.default.createElement("div", {
    className: "display-flex justify-content-center justify-content-around flex-wrap\n                padding-right-2pct-ls padding-left-2pct-ls"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: 'https://www.google.com/chrome/',
    target: '_blank',
    rel: 'noopener noreferrer',
    className: 'display-block hover-scale-110',
    onClick: function onClick() {
      return onBrowserSelect('chrome');
    }
  }, /*#__PURE__*/_react.default.createElement(_chrome.default, null)), /*#__PURE__*/_react.default.createElement("a", {
    href: 'https://www.mozilla.org/firefox/new/',
    target: '_blank',
    rel: 'noopener noreferrer',
    className: 'display-block hover-scale-110',
    onClick: function onClick() {
      return onBrowserSelect('firefox');
    }
  }, /*#__PURE__*/_react.default.createElement(_firefox.default, null))));
};

var _default = BrowserWarningMessageEN;
exports.default = _default;